import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../angular/models/account.model";
import {$accountsFactory} from "../../$accounts.factory";

export class AccountsIndicatorCtrl implements IController {

  accounts?: AccountModel[];
  accountIds?: string[];
  amountToDisplay: number;
  placeholder: string;

  /* @ngInject */
  constructor(private $accounts: $accountsFactory) {
  }

  $onInit() {
    if (!this.amountToDisplay) {
      this.amountToDisplay = 1;
    }

    if (!this.accounts && this.accountIds?.length) {
      this._getAccounts();
    }
  };

  $onChanges(changes) {
    if (changes.accountIds && !changes.accountIds.isFirstChange()) {
      this.accounts = [];
      if (this.accountIds?.length) {
        this._getAccounts();
      }
    }
  };

  private _getAccounts() {
    this.$accounts().$asyncValues(this.accountIds)
      .then((accounts) => {
        this.accounts = accounts;
      })
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('accountsIndicator', {
    bindings: {
      accounts: '<?',
      accountIds: '<?',
      amountToDisplay: '<?',
      placeholder: '<?'
    },
    template: require('./accounts-indicator.html').default,
    controller: AccountsIndicatorCtrl
  });
